import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import strings from '../../strings';

export default class ModalBase extends Component {
    render() {
        return (
            <Modal
                dialogClassName={this.props.modalClassName}
                show={this.props.visible}
                animation={false}
                backdrop={this.props.backdrop}
                onHide={() => this.props.closeModal()}
            >
                <Modal.Header>
                    <Modal.Title>
                        {this.props.modalTitle}
                        <button
                            type="button"
                            className="close"
                            aria-label={strings.close}
                            onClick={() => this.props.closeModal()}
                        >
                            <span>×</span>
                            {/* <span aria-hidden="true">&times;</span> */}
                            <span className="sr-only">{strings.close}</span>
                        </button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.props.children}</Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Modals/Base.jsx